import { useState } from "react";
import { C } from "./constants";

async function callAI(messages, system, maxTokens = 500) {
  const res = await fetch("/api/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ model: "claude-sonnet-4-20250514", max_tokens: maxTokens, system, messages }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(`${res.status}: ${data?.error?.message || "Unknown error"}`);
  if (data.error) throw new Error(data.error.message);
  return data.content?.map(b => b.text||"").join("") || "";
}

// ── MINI COMPONENTS ──────────────────────────────────────────
const Card = ({ children, style={} }) => (
  <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 16, padding: "20px", ...style }}>
    {children}
  </div>
);

const Label = ({ children, style={} }) => (
  <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: C.text3, marginBottom: 8, ...style }}>
    {children}
  </div>
);

const Tag = ({ children, color }) => (
  <span style={{ background: color+"1a", color, borderRadius: 6, padding: "2px 8px", fontSize: 10, fontWeight: 600 }}>
    {children}
  </span>
);

const Btn = ({ children, onClick, variant="primary", style={}, disabled=false }) => {
  const styles = {
    primary: { background: C.green, color: "#0e0e13" },
    ghost:   { background: "rgba(255,255,255,0.05)", color: C.text2, border: `1px solid ${C.border}` },
    danger:  { background: C.redDim, color: C.red, border: `1px solid rgba(240,82,82,0.2)` },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{
      ...styles[variant], borderRadius: 10, padding: "11px 18px", fontSize: 13, fontWeight: 600,
      cursor: disabled ? "not-allowed" : "pointer", border: "none", opacity: disabled ? 0.4 : 1,
      transition: "all 0.15s", outline: "none", ...style
    }}>{children}</button>
  );
};

const Inp = ({ label, ...props }) => (
  <div>
    {label && <Label>{label}</Label>}
    <input {...props} style={{
      width: "100%", background: C.surface2, border: `1px solid ${C.border2}`,
      borderRadius: 10, color: C.text, fontSize: 14, padding: "11px 14px", outline: "none",
      ...(props.style||{})
    }} />
  </div>
);

const Sel = ({ label, children, ...props }) => (
  <div>
    {label && <Label>{label}</Label>}
    <select {...props} style={{
      width: "100%", background: C.surface2, border: `1px solid ${C.border2}`,
      borderRadius: 10, color: C.text, fontSize: 14, padding: "11px 14px", outline: "none",
      ...(props.style||{})
    }}>{children}</select>
  </div>
);

// ── PROGRESS BAR — animates from 0 on mount/key change ───────
const ProgressBar = ({ pct, color=C.green, height=5, style={}, animKey="" }) => {
  const w = Math.min(100, Math.max(0, pct));
  return (
    <div style={{ background:"rgba(255,255,255,0.06)", borderRadius:99, height, overflow:"hidden", ...style }}>
      <div key={animKey + w}
        style={{ "--bar-w": w+"%", width:w+"%", height:"100%", background:color, borderRadius:99,
          animation:"barGrow 0.6s cubic-bezier(0.22,1,0.36,1) forwards" }} />
    </div>
  );
};

// ── SPENDING CHART (line) ─────────────────────────────────────

export { callAI, Card, Label, Tag, Btn, Inp, Sel, ProgressBar };